// extracted by mini-css-extract-plugin
export default {"countdown":"OZ-z","srOnly":"PZ-z"};